"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default_subject = exports.TEST_STATUS = exports.REFRESH_ASSIGNMENT_LIST = exports.selectChatacterScore = exports.selectHistorytScore = exports.selectEnglishScores = exports.englishScores = exports.selectMathScores = exports.mathScores = exports.selectKoreanScores = exports.koreanScores = void 0;
// 국어 점수와 배점
exports.koreanScores = [{ number: '1~34', type: 'objective', score: 2 }];
exports.selectKoreanScores = [
    { number: '35~45', type: 'objective', score: 2 },
];
// 수학 점수와 배점
exports.mathScores = [
    { number: '1~2', type: 'objective', score: 2 },
    { number: '3~8', type: 'objective', score: 3 },
    { number: '9~15', type: 'objective', score: 4 },
    { number: '16~19', type: 'subjective', score: 3 },
    { number: '20~22', type: 'subjective', score: 4 },
];
exports.selectMathScores = [
    { number: '23', type: 'objective', score: 2 },
    { number: '24~27', type: 'objective', score: 3 },
    { number: '28', type: 'objective', score: 4 },
    { number: '29~30', type: 'subjective', score: 4 },
];
// 영어 점수와 배점
exports.englishScores = [{ number: '1~17', type: 'objective', score: 2 }];
exports.selectEnglishScores = [
    { number: '18~45', type: 'objective', score: 2 },
];
exports.selectHistorytScore = [
    { number: '1~20', type: 'objective', score: 2 },
];
exports.selectChatacterScore = [
    { number: '1~30', type: 'objective', score: 2 },
];
// Event Handler
exports.REFRESH_ASSIGNMENT_LIST = 'REFRESH_ASSIGNMENT_LIST';
exports.TEST_STATUS = {
    CREATED: 'created',
    HIDE: 'hide',
    CLOSED: 'closed',
    BOOKED: 'booked',
    OPEN: 'open',
};
// 과목
exports.default_subject = { id: 'select', title: 'common.select' };
